import JTOElement from '../utils/jto/JTOElement';
import JTOObject from '../utils/jto/JTOObject';
import JTOProperty from '../utils/jto/JTOProperty';

export default class FormRegistration extends JTOObject {
    public static _TYPE: string = 'FormRegistration';

    public _paid: JTOProperty<boolean>;

    constructor(parent?: JTOElement | null) {
        super(FormRegistration._TYPE, parent);
        this._paid = new JTOProperty<boolean>('paid', this);
    }

    public get paid(): boolean {
        return this._paid.get() ?? false;
    }
}
